import { render, staticRenderFns } from "./OrderFulfillmentSettingNew.vue?vue&type=template&id=6a3c5e94&scoped=true"
import script from "./OrderFulfillmentSettingNew.vue?vue&type=script&lang=js"
export * from "./OrderFulfillmentSettingNew.vue?vue&type=script&lang=js"
import style0 from "./OrderFulfillmentSettingNew.vue?vue&type=style&index=0&id=6a3c5e94&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c5e94",
  null
  
)

export default component.exports